import React, { useEffect } from 'react';
import Icon from '../Icon';
import useReady from '../../Hooks/useReady';
import clsx from 'clsx';
import { translate } from '../../Services/translation';
import { StepListType } from '../../Reducers/Checkout.reducer';

interface CheckoutStepContainerProps {
  children: React.ReactNode;
  showContent: boolean;
  stepContainerList: StepListType;
  stepKey: string;
  stepComplete?: boolean;
  label: React.ReactNode | string;
  onClick?: () => void;
}

const CheckoutStepContainer = ({
  children,
  label,
  showContent,
  stepContainerList,
  stepKey,
  stepComplete,
  onClick,
}: CheckoutStepContainerProps) => {
  const ready = useReady();
  const length = Object.keys(stepContainerList).length;

  return (
    <div
      onClick={onClick}
      id={stepKey}
      className="step-container mx-auto mb-6 w-full bg-white p-4 lg:max-w-[660px] lg:rounded lg:p-6"
    >
      <div className="flex flex-row items-center">
        {stepComplete && (
          <Icon className="mr-2 h-8 w-8 text-success-400" name="check" />
        )}
        <div className="flex flex-1">
          {typeof label === 'string' ? (
            <h3 className="h3">{label}</h3>
          ) : (
            label
          )}
        </div>
        {}
        <div
          style={{ textShadow: ready ? 'none' : '0 0 10px black' }}
          className={clsx(
            ' duration-400 self-baseline rounded-md bg-gray-100 px-2 py-1 text-md font-bold transition-[text-shadow]',
            !ready && 'text-transparent'
          )}
        >
          {`${translate('general.step')} ${
            stepContainerList[stepKey]
          } ${translate('general.of')} ${length}`}
        </div>
      </div>
      {showContent && <div className="mt-2">{children}</div>}
    </div>
  );
};

export default CheckoutStepContainer;
